import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'

interface InactiveBadgeProps {
  className?: string
  size?: 'sm' | 'md'
}

export function InactiveBadge({ className, size = 'sm' }: InactiveBadgeProps) {
  return (
    <Badge
      variant="outline"
      className={cn(
        'border-muted-foreground/40 bg-muted text-muted-foreground',
        size === 'sm' && 'px-1.5 py-0 text-[10px] leading-4',
        className
      )}
      aria-label="Inactive contact"
    >
      Inactive
    </Badge>
  )
}
